import { Avatar, createStyles, Group, Stack } from '@mantine/core';
import { Text } from '@repo/foundations';
import { memo } from 'react';
import type { QueriedResource } from '../types';
import { ResourceIcon } from './ResourceIcon';

const useStyles = createStyles((theme) => ({
	avatar: {
		backgroundColor: theme.other.getColor('fill/primary/default'),
		border: `1px solid ${theme.other.getColor('border/primary/default')}`,
		minWidth: theme.other.space[8],
	},
}));

interface ResourceListItemProps {
	resource: QueriedResource;
}

export const ResourceListItem = memo(({ resource }: ResourceListItemProps) => {
	const { classes } = useStyles();

	return (
		<Group
			key={`${resource.type}-${resource.name}-${resource.integration_name || 'default'}`}
			spacing="sm"
			noWrap
			align="flex-start"
		>
			<Avatar size="sm" radius="xs" className={classes.avatar}>
				<ResourceIcon resource={resource} />
			</Avatar>
			<Stack spacing={0}>
				<Text size="sm" color="text/primary/default" weight="semibold">
					{resource.name}
				</Text>
				{resource.integration_name && (
					<Text size="xs" color="text/secondary/default" mt={2}>
						from {resource.integration_name}
					</Text>
				)}
			</Stack>
		</Group>
	);
});
